module.exports = __webpack_public_path__ + "img/number_1.4f33ce42.png";